import { HTTPStatusCode } from "@libs/api/types";
import { ListEligibilityCategoriesFilterType } from "@/domain/eligibilityCategory";
import { sendSentryError } from "@/services/sentry";
import { tsRestClient } from "@/services/ts-rest";

export const EligibilityCategoriesApi = {
  listEligibilityCategories: async (
    filters: ListEligibilityCategoriesFilterType,
  ) => {
    const res =
      await tsRestClient().eligibilityCategories.listEligibilityCategories({
        query: filters,
      });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      error: res.body,
      message: "Failed to list eligibility categories",
      shouldThrowError: true,
    });
  },
};
